<ng-container *ngIf="this.fileSrc">
    <div
        *ngIf="this.isImage"
        [style.background-image]="'url(' + this.baseCdnUrl + fileSrc + ')'"
        class="asset-file"></div>

    <div *ngIf="this.isVideo">
        <vg-player (onPlayerReady)="onPlayerReady($event)">
            <video
                [vgDash]="this.baseCdnUrl + fileSrc"
                #vgDash="vgDash"
                controls
                class="video-file"
                preload="metadata"
                #media
                [vgMedia]="media"
                id="singleVideo"
                crossorigin>
                Your browser does not support the video tag.
            </video>
        </vg-player>
    </div>

    <div *ngIf="this.isSVG">
        <img [src]="this.baseCdnUrl + fileSrc" width="100" height="100" />
    </div>
</ng-container>
